import dayjs from '@localization-lib/date-time/dayjs'
import { DEFAULT_TIMEZONE } from '@localization-lib/date-time/dayjs/dayjsHelper'
import { ValueFormatterParams } from 'ag-grid-community'

export const dateFormatterFactory =
    ({
        fallback = '',
        format = 'DD.MM.YYYY',
        timezone = DEFAULT_TIMEZONE,
    }: {
        fallback?: ''
        format?: string
        timezone?: string
    } = {}) =>
    (params: ValueFormatterParams) =>
        dayjs(params.value).tz(timezone).format(format) || fallback
